import { render } from "./ListarClientes.vue?vue&type=template&id=a6d396e2"
import script from "./ListarClientes.vue?vue&type=script&lang=js"
export * from "./ListarClientes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__